document.addEventListener('DOMContentLoaded', function () {
  // ---- EFFECTIVE LIMIT FOR PLUS/MINUS ----
  function getLimitForPlus(card){
    const isPre   = String(card.getAttribute('data-preorder-live')) === 'true';
    const stock   = parseInt(card.getAttribute('data-max-quantity') || '0', 10);
   const cap = parseInt(card.getAttribute('data-preorder-cap') || '0', 10);
    if (isPre && stock <= 0) return cap > 0 ? cap : 999999; // preco without limit front if cap not defined
    return stock; // normal case: stock
  }

  function updateRollNote(card){
  // Only displayed for Nicotine Pouches
  const type = (card.getAttribute('data-type') || '').toLowerCase();
  //if (!type || type !== 'nicotine-pouches') return;
  if (!type || type !== 'nicotine-pouches') return;

  const input = card.querySelector('.quantity-input');
  const note  = card.querySelector('.roll-note');
  if (!input || !note) return;

  const val = parseInt(input.value || '0', 10) || 0;
  note.style.display = val > 0 ? 'block' : 'none';
}



  // Button +
  document.querySelectorAll('.plus-btn').forEach(function (button) {
    button.addEventListener('click', function () {
      const card = button.closest('.product-card');
      const quantityInput = card.querySelector('.quantity-input');
      const currentQuantity = parseInt(quantityInput.value) || 0;
      const limitForPlus = getLimitForPlus(card);

      if (currentQuantity < limitForPlus) {
        quantityInput.value = currentQuantity + 1;
      } else {
        const isPre = String(card.getAttribute('data-preorder-live')) === 'true';
        alert(isPre ? "You have reached the maximum pre-order quantity." :
                      "You cannot add any more items to the cart.");
      }

      // we keep the stock logic for the “Add” button
      updateAddButtonState(
        card.getAttribute('data-variant-id'),
        card.getAttribute('data-max-quantity')
      );
      updateRollNote(card);
    });
  });

  // Button -
  document.querySelectorAll('.minus-btn').forEach(function (button) {
    button.addEventListener('click', function () {
      const card = button.closest('.product-card');
      const quantityInput = card.querySelector('.quantity-input');
      const currentQuantity = parseInt(quantityInput.value) || 0;

      if (currentQuantity > 0) quantityInput.value = currentQuantity - 1;

      updateAddButtonState(
        card.getAttribute('data-variant-id'),
        card.getAttribute('data-max-quantity')
      );
      updateRollNote(card);
    });
  });

  // Update the “Add” button (keep your original logic)
  function updateAddButtonState(variantId, maxQuantity) {
    const quantityInput = document.querySelector('[data-variant-id="' + variantId + '"] .quantity-input');
    const currentQuantity = parseInt(quantityInput?.value) || 0;
    const addButton = document.querySelector('[data-variant-id="' + variantId + '"] .add-button');
    if (!addButton) return; // if card is pre-ordered: no “Add” button
    const stockMax = parseInt(maxQuantity || '0', 10);
    addButton.disabled = currentQuantity > stockMax;
  }

  // Add to cart (ONE BLOCK ONLY)
  document.querySelectorAll('.add-button').forEach(function (button) {
    button.addEventListener('click', function () {
      const variantId = button.closest('.product-card').getAttribute('data-variant-id');
      const quantity = parseInt(button.closest('.quantity-validation-wrapper').querySelector('.quantity-input').value) || 0;
      if (quantity > 0) addToCart(variantId, quantity);
    });
  });

function addToCart(variantId, quantity) {
  const card = document.querySelector('[data-variant-id="' + variantId + '"]');
  const addButton = card.querySelector('.add-button');
  const group = card.getAttribute('data-limit-group'); // ← “ecigs” or empty
  addButton.textContent = '...';

  // If group → we use fetch to send the property; otherwise we keep Shopify.addItem
  if (group) {
    const body = new URLSearchParams();
    body.append('id', variantId);
    body.append('quantity', quantity);
    body.append('properties[_limit_group]', group);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: body.toString()
    })
    .then(r => r.ok ? r.json() : Promise.reject(r))
    .then(() => afterAddSuccess(card, addButton, variantId))
    .catch(() => restoreBtn(addButton));
  } else {
    Shopify.addItem(variantId, quantity, function () {
      afterAddSuccess(card, addButton, variantId);
    });
  }

  function afterAddSuccess(card, addButton, variantId){
    addButton.innerHTML = '<span class="checkmark-icon"><svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M7.5 10l3 3 7-7" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';

    const input = card.querySelector('.quantity-input');
    if (input) input.value = 0;
    if (typeof updateRollNote === 'function') updateRollNote(card);

    if (window.Shopify && typeof Shopify.getCart === 'function') Shopify.getCart();
    document.dispatchEvent(new CustomEvent('cart:updated'));

    setTimeout(() => { addButton.textContent = 'Add'; }, 1200);
  }

  function restoreBtn(addButton){
    addButton.textContent = 'Ajouter';
    addButton.disabled = false;
    alert("Error adding to cart");
  }
}
});

/*Empêcher la saisie clavier > cap en préco*/
document.addEventListener('input', function(e){
  const input = e.target.closest('.quantity-input');
  if(!input) return;
  const card = e.target.closest('.product-card');
  if(!card) return;

  const isPre   = String(card.getAttribute('data-preorder-live')) === 'true';
  const stock   = parseInt(card.getAttribute('data-max-quantity') || '0', 10);
  const cap = parseInt(card.getAttribute('data-preorder-cap') || '0', 10);

  let max = stock;
  if(isPre && stock <= 0){ max = cap > 0 ? cap : 999999; }
  let val = parseInt(input.value || '0', 10);
  if(isNaN(val) || val < 0) val = 0;
  if(val > max) val = max;
  input.value = String(val);
  // Show/hide “10-roll” if applicable
const cardForNote = input.closest('.product-card');
if (cardForNote) {
  // reuses the same logic (local copy for this listener outside scope)
  const type = (cardForNote.getAttribute('data-type') || '').toLowerCase();
  const note = cardForNote.querySelector('.roll-note');
  if (type === 'nicotine-pouches' && note) {
    note.style.display = val > 0 ? 'block' : 'none';
  }
}

});


/***
Ajoute/modifie le script pour qu’il :
filtre les .product-card
cache les .product-block et .vendor-block si aucun enfant visible
***/

document.addEventListener("DOMContentLoaded", function () {
  const vendorFilter = document.getElementById("vendor-filter");
  const typeFilter = document.getElementById("type-filter");

  function applyFilters() {
    const selectedVendor = vendorFilter.value;
    const selectedType = typeFilter.value;
    const cards = document.querySelectorAll(".product-card");

    cards.forEach(card => {
      const cardVendor = card.dataset.vendor;
      const cardType = card.dataset.type;

      const matchVendor = selectedVendor === "all" || cardVendor === selectedVendor;
      const matchType = selectedType === "all" || cardType === selectedType;

      card.style.display = (matchVendor && matchType) ? "block" : "none";
    });

// hide product blocks without visible products
document.querySelectorAll(".product-block").forEach(block => {
  const hasVisible = block.querySelector(".product-card[style*='display: block']");
  block.style.display = hasVisible ? "block" : "none";
});

// hide vendor blocks without visible products
document.querySelectorAll(".vendor-block").forEach(block => {
  const hasVisible = block.querySelector(".product-card[style*='display: block']");
  block.style.display = hasVisible ? "block" : "none";
});

  }

  vendorFilter.addEventListener("change", applyFilters);
  typeFilter.addEventListener("change", applyFilters);
});

